<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>Work Details</md-icon>
                    </div>
                    <h4 class="title">Add Work Detail</h4>
                </md-card-header>

                <form @submit.prevent="add">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Commodity
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="workDetail.commodity"/>
                                    <validation-error :errors="apiValidationErrors.commodity"/>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Item Number
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="workDetail.item_number"/>
                                    <validation-error :errors="apiValidationErrors.item_number"/>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Item Type
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="workDetail.item_type"/>
                                    <validation-error :errors="apiValidationErrors.item_type"/>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Date
                            </label>
                            <div class="md-layout-item">
                                <md-datepicker
                                        v-model="workDetail.date"
                                        :md-model-type="String"
                                        :class="{ 'md-invalid': !!apiValidationErrors.date }"
                                >
                                    <label>Select date ...</label>
                                    <validation-error :errors="apiValidationErrors.date" />
                                </md-datepicker>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Remarks
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="workDetail.remarks"/>
                                    <validation-error :errors="apiValidationErrors.remarks"/>
                                </md-field>
                            </div>
                        </div>


                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Work Item
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="workDetail.workItem" name="workItems">
                                        <md-option
                                                v-for="workItem in available_workItems_dropdown"
                                                :key="workItem.id"
                                                :value="workItem.id"
                                        >
                                            {{ workItem.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>

                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Add Work Detail</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>
<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';

export default {
    components: { ValidationError },

    mixins: [formMixin],

    data: () => ({

        workDetail: {
            type: 'workDetails',
            commodity: null,
            item_number: null,
            item_type: null,
            work_item_id: null,
        },
        available_workItems_dropdown: [],
    }),
    created () {
        this.getWorkItemsDropDowns();
    },
    methods: {
        async add () {
            try {
                await this.$store.dispatch('workDetails/add', this.workDetail);
                this.notifySuccess('Work Detail added successfully.');
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].title);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
            }
        },
        getWorkItemsDropDowns () {
            this.$store.dispatch('workItems/list').then(() => {
                console.log(this.$store);
                this.available_workItems_dropdown = this.$store.getters['workItems/dropdown'];
                if (this.available_workItems_dropdown && this.available_workItems_dropdown.length) {
                    this.workDetail.work_item_id = this.available_workItems_dropdown[0].id;
                }
            });
        },

        goBack () {
            this.$router.push({ name: 'Work Details List' });
        },
    },
};
</script>
